import { useState } from "react";
import AlertDialog from "./layouts/AlertDialog";

import data from "../data.json";
import { STR } from "./string";

const DemoPage = () => {
    const [dummy, setDummy] = useState(STR);
    const [alert, setAlert] = useState({ show: false, isloading: false, id: null });
    const [show, setShow] = useState(false);
    const [px, setPx] = useState(0);
    const [py, setPy] = useState(0);
    const [position, setPosition] = useState("");

    const handleMouseUp = (e) => {
        // let tmp = document.createElement("DIV");
        //     tmp.innerHTML = STR;
        //     let mainString = tmp.textContent || tmp.innerText || "";
        //     console.log(window.getSelection().toString())
        // while (container.firstChild) {
        //     container.removeChild(container.firstChild);
        // }
        // console.log(container.textContent);
        // let str = STR;

        // let selection;
        // if (window.getSelection) {
        //     selection = window.getSelection();
        // } else if (document.selection) {
        //     selection = document.getSelection();
        // }

        // var start = window.getSelection().baseOffset;
        // var end = window.getSelection().focusOffset;
        // if (start < end) {
        //     var start = window.getSelection().baseOffset;
        //     var end = window.getSelection().focusOffset;
        // } else {
        //     var start = window.getSelection().focusOffset;
        //     var end = window.getSelection().baseOffset;
        // }
        // console.log(start,end);
        // console.log(selection);
        
        //   console.log(window.getSelection())
        if(window.getSelection().toString() !== '') {
            const selOffsets = checkHighlight(document.querySelector('#content_canvas'));
            let content_id = selOffsets.start + "," + selOffsets.end;
            //   var range = selection.getRangeAt(0);
            // //   var selectionContents = range.extractContents();
            // //   console.log(range.extractContents())
      
            //   var startOffset = range.startOffset;
            //   var endOffset = startOffset + range.toString().length - 1;
      
            //   console.log(range.getBoundingClientRect(), range.startOffset, range.endOffset)
            //   console.log("Selection starts at: " + startOffset);
            //   console.log("Selection ends at: " + endOffset);
            //   // console.log(selection.getRangeAt(0));
            
            setPosition(content_id)
            setPx(e.pageX);
            setPy(e.pageY);
            setShow(true);
          } else {
            setPx(0);
            setPy(0);
            setShow(false);
          }
        //   selection.toString() !== '' && console.log(dummy.indexOf(selection), dummy.indexOf(selection) + selection.toString().length);
        // setAlert({ show: true, isloading: false, id: null })
    }
    const handleTagClick = (docId, tagname) => {

        var selOffsets = getSelectionCharacterOffsetWithin(document.getElementById("content_canvas"));
        let firstindex = selOffsets.start;

        let lastindex = selOffsets.end;

        // console.log(selOffsets);
        // console.log(e);
        // if(tagname === 'issue') {

        //     // let output = STR;
            
        //     // let tmp = document.createElement("DIV");
        //     // tmp.innerHTML = STR;
        //     // let mainString = tmp.textContent || tmp.innerText || "";

        //     // let count = 0;

        //     // data.docs[0].keys.index.forEach((key) => {
        //     //     // dd = data.docs[0].doc.substr(key.first, key.last) + '<span className="bg-yellow">' +  data.docs[0].doc.substr(key.last, key.last - key.first + 1) + '</span>' + data.docs[0].doc.substr(key.last + 1);
        //     //     // return dd = [data.docs[0].doc.slice(0, key.first), '<span class="bg-yellow-500">', data.docs[0].doc.slice(0, key.last), '</span>',data.docs[0].doc.slice(key.first)].join('');
        //     //     // let str = "Lorem Ipsum is simply dummy text of the printing and typesetting industry.";
                
        //     //     // dd = str.substring(0, key.first) 
        //     //     // + '<span class="bg-yellow-500">' 
        //     //     // + str.substring(key.first, key.last + 1)
        //     //     // + '</span>';
        //     //     // + str.substring(key.last + 1, str.length);
    
        //     //     // console.log(output.substring(key.first + count, key.last + count + 1));
        //     //     // output = output.substring(0, key.first + count) 
        //     //     //         + '<span class="bg-green-500">'
        //     //     //         + output.substring(key.first + count, key.last + count + 1)
        //     //     //         + '</span>'
        //     //     //         + output.substring(key.last + count + 1, output.length);
        //     //     // console.log(mainString.substring(key.first, key.last + 1));
        //     //     output = output.replace(mainString.substring(key.first, key.last + 1), '<span class="bg-green-500">' + mainString.substring(key.first, key.last + 1) + '</span>');
    
        //     //     // return dd = addStr(data.docs[0].doc, 0,'<span className="bg-yellow">');
        //     //     // count += 34;
        //     // });
        //     // let len = 0;
        //     // dd = data.docs[0].doc;
        //     // console.log('span class="bg-yellow-500"'.length,'</span>'.length)
    
        //     // ll.forEach((item) => {
        //     //     dd = dd.replace(item, '<span class="bg-yellow-500">' + item + '</span>');
        //     // });
        //     // setDummy(output);
        //     // console.log(ll);
        //     // console.log(dd);
        // } else {
        //     setDummy(STR)
        // }

    }

    function getSelectionCharacterOffsetWithin(element)
    {
        console.log(element)
        var start = 0;
        var end = 0;
        var doc = element.ownerDocument || element.document;
        var win = doc.defaultView || doc.parentWindow;
        var sel;
        if (typeof win.getSelection != "undefined") 
        {
            sel = win.getSelection();
            if (sel.rangeCount > 0) 
            {
                    var range = win.getSelection().getRangeAt(0);
                    var newNode = document.createElement("span");
                    
                    newNode.setAttribute("style", "background-color: yellow; white-space: break-spaces;");
                    // newNode.setAttribute('id', range);
                    newNode.appendChild(range.extractContents());
                    range.insertNode(newNode);
                    
                    // range.surroundContents(newNode);
                    
                    var preCaretRange = range.cloneRange();
                    console.log(preCaretRange)
                    preCaretRange.selectNodeContents(element);
                    
                    preCaretRange.setEnd(range.startContainer, range.startOffset);
                    start = preCaretRange.toString().length;
                    
                    preCaretRange.setEnd(range.endContainer, range.endOffset);
                    end = preCaretRange.toString().length;
                    setDummy(range)
            }
        } 
        else if ((sel = doc.selection) && sel.type != "Control")
        {
                    var textRange = sel.createRange();
                    var preCaretTextRange = doc.body.createTextRange();

                    preCaretTextRange.moveToElementText(element);
                    preCaretTextRange.setEndPoint("EndToStart", textRange);

                    start = preCaretTextRange.text.length;
                    preCaretTextRange.setEndPoint("EndToEnd", textRange);

                    end = preCaretTextRange.text.length;
                    setDummy(textRange)
        }
        return {start: start, end: end};
    }  

    function checkHighlight(element) {
        var start = 0;
        var end = 0;
        var doc = element.ownerDocument || element.document;
        var win = doc.defaultView || doc.parentWindow;
        var sel;
        if (typeof win.getSelection != "undefined") {
            sel = win.getSelection();
            if (sel.rangeCount > 0) {
                var range = win.getSelection().getRangeAt(0);

                var preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(element);

                preCaretRange.setEnd(range.startContainer, range.startOffset);
                start = preCaretRange.toString().length;

                preCaretRange.setEnd(range.endContainer, range.endOffset);
                end = preCaretRange.toString().length - 1;
            }
        } else if ((sel = doc.selection) && sel.type != "Control") {
            var textRange = sel.createRange();
            var preCaretTextRange = doc.body.createTextRange();

            preCaretTextRange.moveToElementText(element);
            preCaretTextRange.setEndPoint("EndToStart", textRange);

            start = preCaretTextRange.text.length;
            preCaretTextRange.setEndPoint("EndToEnd", textRange);

            end = preCaretTextRange.text.length - 1;
        }
        return {
            start: start,
            end: end
        };
    }


    const handleDelete = (e) => {
        console.log(e);
    }
    return (
        <div className="flex">
            <div className="bg-white rounded-lg border border-gray-200 w-48 text-gray-900 text-sm font-medium">
                {
                    data.keys.map((item, index) => {
                        return (
                            <button key={index} onClick={() => handleTagClick(item.docId, item.name)} className="block px-4 py-2 border-b border-gray-200 w-full hover:bg-gray-100 hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-700 focus:text-blue-700 cursor-pointer">
                                {item.name}
                            </button>
                        )
                    })
                }
            </div>

            <div className="text-white p-5">
            <p>Hi, How are you?</p>

                {/* {
                    data.docs.map((item, index) => {
                        return (
                        );
                    })
                } */}
                {/* <p onMouseUp={(e) => handleMouseUp(e, data.docs[0])} className="mb-3">
                {dummy}
                </p> */}
                <div id="content_canvas" onMouseUp={(e) => handleMouseUp(e, data.docs[0])} className="mb-3" dangerouslySetInnerHTML={{__html: dummy}}>
                </div>
            </div>

            <ul className="absolute right-0 mt-2 py-2 w-48 bg-white rounded-md shadow-xl z-20" style={{ display: show?'':'none', left: px, top: py }}>
                <li className="block px-4 py-2 text-sm capitalize text-gray-700 hover:bg-blue-500 hover:text-white">
                String Position: {position}
                </li>
                <button className="w-full text-left block px-4 py-2 text-sm capitalize text-gray-700 hover:bg-blue-500 hover:text-white">
                your profile
                </button>
                <button className="w-full text-left block px-4 py-2 text-sm capitalize text-gray-700 hover:bg-blue-500 hover:text-white">
                Your projects
                </button>
                <li  onClick={() => handleTagClick(1, 'issue')} className="block px-4 py-2 text-sm capitalize text-gray-700 hover:bg-blue-500 hover:text-white">
                Highlight
                </li>
                <li className="block px-4 py-2 text-sm capitalize text-gray-700 hover:bg-blue-500 hover:text-white">
                Settings
                </li>
                <li className="block px-4 py-2 text-sm capitalize text-gray-700 hover:bg-blue-500 hover:text-white">
                Sign Out
                </li>
            </ul>

            <AlertDialog
                    show={alert.show}
                    isloading={alert.isloading}
                    title="Confirm delete?"
                    description="Are you sure want to delete this item. Confirm delete."
                    ok="Confirm"
                    handleCancel={() => setAlert({ show: false, isloading: false, id: null })}
                    handleOk={handleDelete}
                />
        </div>
    );
}

export default DemoPage;